module.exports = __webpack_public_path__ + "static/media/logo-dipp-mark.1faba9a8.svg";